import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";

export default function NotFound() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16 min-h-[70vh] flex items-center justify-center">
        <div className="text-center px-4">
          <div className="w-20 h-20 mx-auto rounded-full bg-primary-50 flex items-center justify-center mb-6">
            <i className="ri-file-damage-line text-4xl text-primary-500" />
          </div>
          <h1 className="text-5xl font-heading font-bold text-foreground-950">404</h1>
          <h2 className="text-xl font-semibold text-foreground-700 mt-3">页面找不到</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md">
            你访问的页面似乎已经消失了，可能是被施了隐身术。<br />
            试试返回首页，继续享受漫画阅读吧！
          </p>
          <Link
            to="/"
            className="inline-block mt-8 px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            返回首页 <i className="ri-home-5-line ml-1" />
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}